import { render, staticRenderFns } from "./PartnerUserList.vue?vue&type=template&id=1269aa5e&scoped=true"
import script from "./PartnerUserList.vue?vue&type=script&lang=ts"
export * from "./PartnerUserList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269aa5e",
  null
  
)

export default component.exports